export const classNames = (...args) => {
    const classes = [];

    args.forEach(arg => {
        if (!arg) return;

        const argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
            classes.push(arg);
        } else if (Array.isArray(arg)) {
            classes.push(classNames(...arg));
        } else if (argType === 'object') {
            Object.keys(arg).forEach(key => {
                if (arg[key]) {
                    classes.push(key);
                }
            });
        }
    });

    return classes.join(' ');
};
